import { z } from "zod/v4";

import { castToNumber } from "../utils";

export const RateConditionTypeList = ["currency", "weight"] as const;
export type RateConditionType = (typeof RateConditionTypeList)[number];

export const ConditionTypeList = ["g", "kg", "lb", "oz"] as const;
export type ConditionType = (typeof ConditionTypeList)[number];

export const ShippingRateConditionDtoSchema = z.object({
  id: z.uuid().optional(),
  min: castToNumber.nullish().default(0),
  max: castToNumber.nullish(),
  conditionType: z.enum(RateConditionTypeList), // maybe we type this
  unit: z.enum(ConditionTypeList).nullish(),
});

export type ShippingRateConditionDto = z.infer<
  typeof ShippingRateConditionDtoSchema
>;
